import { useTranslation } from 'react-i18next';

import { SidebarTrigger, useSidebar } from '@/components/ui/sidebar';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface SidebarToggleProps {
  className?: string;
}

/** Bouton d'ouverture / fermeture du menu principal, avec tooltip selon l'état courant. */
export const SidebarToggle = ({ className }: SidebarToggleProps) => {
  const { t } = useTranslation();
  const { open, openMobile, isMobile } = useSidebar();
  const expanded = isMobile ? openMobile : open;
  const label = expanded ? t('layout.sidebar.collapse') : t('layout.sidebar.expand');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <SidebarTrigger className={className} aria-label={label} />
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};
